import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, TextArea } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'

export const ChatEdit = ({
  requestTypeValid,
  currentText,
  buttonText,
  onChange,
  ...props
}) => {
  const isRequestValid = () => {
    const msgBox = document.getElementById('chatMessage')
    const message = msgBox ? msgBox.value.trim() : ''
    return message.length > 0 && requestTypeValid
  }

  const [text, setText] = useState('')

  const [requestValid, setRequestValid] = useState(isRequestValid())
  useEffect(() => setRequestValid(isRequestValid()), [requestTypeValid, text])

  const onTextChange = e => {
    setText(e.target.value)
    onChange(e.target.value)
  }

  const onSend = () => {
    const msgBox = document.getElementById('chatMessage')
    const message = msgBox.value.trim()
    msgBox.value = ''
    props.onSend(message)
  }

  const keyEnterListener = e => {
    if (requestValid && (e.keyCode === 10 || e.keyCode === 13)) {
      e.preventDefault()
      onSend()
    }
  }

  useEffect(() => {
    window.addEventListener('keyup', keyEnterListener)
    return () => window.removeEventListener('keyup', keyEnterListener)
  }, [])
  return (
    <div>
      <TextArea
        id="chatMessage"
        label={getText('chat.editor.message')}
        skipValidation
        value={currentText || ''}
        onChange={onTextChange}
      />
      <Button type="primary" onClick={() => onSend()} disabled={!requestValid}>
        {buttonText}
      </Button>
    </div>
  )
}

ChatEdit.propTypes = {
  currentText: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  onSend: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  requestTypeValid: PropTypes.bool.isRequired,
}

ChatEdit.defaultProps = {
  currentText: null,
}
